import  AudioManager  from "../audio/AudioManager";

export abstract class AdSDKHelper {

    static current: AdSDKHelper;

    protected _soundAlreadyMuted: boolean;
    protected _rewardedAdReady: boolean;
    get IsRewardedAdReady() {
        return this._rewardedAdReady;
    }
    protected _callback: ((success: boolean) => void) | null;
    protected _context: any;

    constructor() {
        this._callback = null;
        this._context = null;
    }

    abstract init(): void;

    abstract showInterstitialAd(callback: (success: boolean) => void, context: any): void;

    abstract loadRewardedAd(): void;

    abstract showRewardedAd(callback: (success: boolean) => void, context: any): void;

    abstract error(): void;


    protected _pauseAndMuteGame() {
        //Pause game here
        AudioManager.mute();
    }
    protected _resumeAndUnmuteGame() {
        //Resume game
        if (!this._soundAlreadyMuted) {
            AudioManager.unmute();
        }
    }

    protected _setCallbackAndContext(callback: (success: boolean) => void, context: any) {
        this._callback = callback;
        this._context = context;
    }

    protected _callCallback(success: boolean) {
        if (this._callback != null) {
            this._callback(success);
            this._callback = null;
        }
    }
}
